/// <amd-module name="Search/Code/Flux/Stores/SearchStore" />
import * as Utils from "Search/Code/Utils";
import * as BaseSearchStore from "Search/Shared/Base/Stores/SearchStore";
import { CodeQueryResponse, SearchQuery, CodeResult } from "Search/LegacyWebApi/Contracts/Code";
import { ISortOptionChangedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";

export class SearchStore extends BaseSearchStore.SearchStore<SearchQuery, CodeQueryResponse, CodeResult> {
    constructor(changedEventName: string, data?: ISeedData<CodeResult>) {
        super(changedEventName);
        if (data && data.responseWithActivityId) {
            const responseWithActivityId = data.responseWithActivityId;
            const response = responseWithActivityId.response as CodeQueryResponse;
            this._state = {
                query: response.query,
                response: response,
                searchStatus: BaseSearchStore.SearchStatus.Success,
                activityId: responseWithActivityId.activityId && responseWithActivityId.activityId[0],
                source: data.source
            };
        } else if (data && data.error) {
            this._state = {
                query: data.error.query,
                response: undefined,
                searchStatus: BaseSearchStore.SearchStatus.Failed,
                activityId: data.error.activityId,
                source: data.source,
                error: data.error.error
            }
        }
    }

    public isEmptyResponse = (): boolean => {
        return this._state?.response?.results?.count === 0;
    }

    public areCorrectResultsLoaded = (query: SearchQuery, response: CodeQueryResponse): boolean => {
        query.takeResults = response.query.takeResults;
        return Utils.areQueriesSame(query, response.query);
    }

    public areQueriesSame = (queryInState: SearchQuery, queryInPayload: SearchQuery): boolean => {
        return Utils.areQueriesSame(queryInState, queryInPayload);
    }

    public updateItemsOnSort = (payload: ISortOptionChangedPayload<CodeResult>): void => {
        // Response could be null in case sort is performed after an error ocurred.
        if (this._state.response) {
            this._state.response.results.values = payload.sortedItems;
            this.emitChanged();
        }
    }

    public getUpdatedResponse = (responseInPayload: CodeQueryResponse): CodeQueryResponse => {
        const { response, fetchMoreScenario } = this._state;
        if (!fetchMoreScenario || !response) {
            return responseInPayload;
        }

        response.results.values.push(...responseInPayload.results.values);
        return response;
    }
}
